import { createFileRoute } from '@tanstack/react-router';
import { BillsPage } from '@/features/checkout/pages/bills-page';

export const Route = createFileRoute('/_app/bills')({ component: BillsPage });
